import { render } from "./workflowcard-add.vue?vue&type=template&id=cd434e44"
import script from "./workflowcard-add.vue?vue&type=script&lang=js"
export * from "./workflowcard-add.vue?vue&type=script&lang=js"

import "./workflowcard-add.vue?vue&type=style&index=0&id=cd434e44&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__